module.exports = __webpack_public_path__ + "static/media/symbolLogo.3629aa50.svg";